@import 'apps/webcomponents/src/assets/common.scss';

#suspend-recursive-toggle {
  margin-top: 16px;
}

.suspend-recursive-text {
  margin-top: 8px;
}
